<template>
  <v-flex>
    <b v-if="$vuetify.breakpoint.smAndDown">Loaded {{ siteDistanceMeasureUnitsLabel }}:</b>
    {{ distanceLabel(loadModel.loadedMiles(loadDetails)) }}
    <span class="font-italic"
          v-if="loadModel.billOfLadingNumber(loadDetails)">
      ({{ $t('terms.bill-of-lading.abbr') }}: {{loadModel.billOfLadingNumber(loadDetails)}})
    </span>
    <br />
    <template v-if="showRequirements">
      <span v-if="loadModel.requiresWashout(loadDetails)">
          <icon-base width="25" height="25" icon-color="#352208" icon-name="hose">
            <icon-hose />
          </icon-base>
      </span>
      <span v-if="loadModel.requireWoodChips(loadDetails)">
        <icon-base width="25" height="25" icon-color="#352208"
                   viewBox="0 0 5 5" icon-name="wood">
          <icon-wood />
        </icon-base>
      </span>
      <span v-if="loadModel.requireWeatherboards(loadDetails)">
        <icon-base width="25" height="25" icon-name="cold" icon-color="#352208">
          <icon-cold />
        </icon-base>
      </span>
    </template>
    <span v-else class="font-italic">
      based on Google Maps
    </span>
  </v-flex>
</template>

<script>
import { mapGetters } from 'vuex';
import Model from '@/types/models/';
import IconBase from '@/components/IconBase';
import IconCold from '@/components/icons/IconCold';
import IconHose from '@/components/icons/IconHose';
import IconWood from '@/components/icons/IconWood';
import unitsOfMeasurePlugin from '../../mixins/unitsOfMeasurePlugin';

export default {
  name: 'LoadDistance',
  components: {
    IconBase,
    IconHose,
    IconWood,
    IconCold,
  },
  mixins: [
    unitsOfMeasurePlugin,
  ],
  props: {
    loadDetails: {
      type: Object,
    },
    showRequirements: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    loadModel() {
      return Model.load;
    },
    ...mapGetters('profiles', {
      isLtnAdmin: 'isLtnAdmin',
    }),
  },
  methods: {
    ...mapGetters('profiles', {
      findCompanyAccount: 'findCompanyAccount',
    }),
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/InfoWidgets/LoadDistance.vue